export enum SupplierSignupTypeEnum {
  Driver = 1,
  Agent = 2,
}
